import {SOURCE_TYPE} from './constants'
import {isSource} from './utility'

export function showHeader() {
  return !isSource(SOURCE_TYPE.ITK)
}
